<template>

    <v-dialog
          v-model="dialog.show"
          @keydown.esc="onClose"
          max-width="380"
        >
        <v-card flat tile>
          
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <h5 class="white--text font-weight-light">
                <template>Location</template>
              </h5>
            </v-toolbar-title>
            <v-spacer />
            <base-icon-close @close="onClose" :x_small="true"></base-icon-close>
          </v-toolbar>

          <v-card-text>
            <ValidationObserver ref="observer" v-slot="{ handleSubmit,invalid }">
              <v-form style="width: 320px">
                <v-row no-gutters>
                  <v-col cols="12" md="12">
                    <ValidationProvider
                      v-slot="{ validate, errors }"
                      name="Name"
                      vid="name"
                      rules="required"
                    >
                      <v-text-field
                        v-model="locationData.name"
                        label="Naziv"
                        color="primary"
                        dense
                        outlined
                        :error-messages="errors"
                        id="name"
                        hide-details="auto"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                    <v-col cols="12" md="12">
                        <ValidationProvider
                        v-slot="{ validate, errors }"
                        name="Longitude"
                        vid="longitude"
                        rules="required"
                        >
                        <v-text-field
                            v-model="locationData.longitude"
                            label="Geografska dužina"
                            color="primary"
                            dense
                            outlined
                            :error-messages="errors"
                            id="longitude"
                            hide-details="auto"
                            type="number"
                        ></v-text-field>
                        </ValidationProvider>
                    </v-col>

                    <v-col cols="12" md="12">
                        <ValidationProvider
                        v-slot="{ validate, errors }"
                        name="Latitude"
                        vid="latitude"
                        rules="required"
                        >
                        <v-text-field
                            v-model="locationData.latitude"
                            label="Geografska širina"
                            color="primary"
                            dense
                            outlined
                            :error-messages="errors"
                            id="latitude"
                            hide-details="auto"
                            type="number"
                        ></v-text-field>
                        </ValidationProvider>

                    </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-card-text>

          <v-card-actions>
            <v-row no-gutters class="mr-2">
              <v-col offset="6" cols="3">
                <v-btn block small color="secondary" class="white--text font-weight-light"  @click="onClose">
                <slot>{{defaultSlotText}}</slot>
              </v-btn>
              </v-col>
              <v-col cols="3">
                <v-btn  block small color="primary" class="white--text font-weight-light ml-2" @click="onSubmit">
                <slot name="submit">{{defaultSubmitText}}</slot>
              </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>

        </v-card>

    </v-dialog>

</template>

<script>
import { mapGetters } from 'vuex'
import httpClient from '../../api/httpClient'
import translate from '@/utils/genTable/multilanguageHelper.js'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import i18n from '@/plugins/i18n'

extend('required', {
  ...required,
  message: (_, values) => i18n.t('validations.required', values)
})
export default {
  name: 'MapLocationCrudComponent',
  components: {
    ValidationProvider,
    ValidationObserver,
    BaseIconClose: () => import('@/components/BaseIconClose')
  },
  props: {
    locationData: {
      type: Object,
      required: true
    },
    dialog: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      labels: {
        poiDetails: translate('POI details', 'maps')
      },
      errors: null,
      defaultSlotText: translate('Cancel', 'buttons'),
      defaultSubmitText: translate('Confirm', 'buttons')
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      getErrors: 'genTables/errors',
      actionSucceded: 'genTables/success'
    })
  },
  methods: {
    save() {
      httpClient
        .post('/locations', {
          name: this.locationData.name,
          longitude: this.locationData.longitude,
          latitude: this.locationData.latitude
        })
        .then(() => {
          this.errors = null
          window.location.reload()
        })
        .catch(err => {
          this.errors = err.response.data.errors
          if (err.response.status != 422) {
            this.$emit('mapCrudFormEvent', err.response.data.title)
            this.errors = null
          }
        })
    },
    edit() {
      httpClient
        .put(`/locations/${this.locationData.id}`, {
          name: this.locationData.name,
          longitude: this.locationData.longitude,
          latitude: this.locationData.latitude
        })
        .then(() => {
          //   this.$emit('mapCrudFormEvent', null)
          this.errors = null
          window.location.reload()
        })
        .catch(err => {
          this.errors = err.response.data.errors
          if (err.response.status != 422) {
            this.$emit('mapCrudFormEvent', err.response.data.title)
            this.errors = null
          }
        })
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toLowerCase() + string.slice(1)
    },
    onSubmit() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          if (this.locationData.edit) {
            return this.edit()
          } else {
            return this.save()
          }
        }
      })
    },
    onClose() {
      this.$emit('close')
    }
  },
  watch: {
    errors: {
      handler() {
        var errorsObject = {}
        for (let prop of this.errors) {
          errorsObject[this.capitalizeFirstLetter(prop.PropertyName)] = [
            prop.Error
          ]
        }
        this.$refs.observer.setErrors(errorsObject)
      }
    }
  }
}
</script>

<style scoped>
.col-md-12 {
  padding: 2px !important;
}
</style>
